import { render, staticRenderFns } from "./ProjectPublic.vue?vue&type=template&id=891986d6&scoped=true"
import script from "./ProjectPublic.vue?vue&type=script&lang=ts"
export * from "./ProjectPublic.vue?vue&type=script&lang=ts"
import style0 from "./ProjectPublic.vue?vue&type=style&index=0&id=891986d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891986d6",
  null
  
)

export default component.exports